require("../../libs/backbone/backbone.ajaxq.adapter.ts");
var GenericView = require('views/generic.view.ts');
var Handlebars = require('handlebars');
var Template = require('text-loader!../templates/advance_options.template.htm');
require('dhtmlxMessage');
var HandlebarsHelpers = require('../../libs/handlebars/handlebars-helpers.ts');
var VenuesCollection = require('../models/venues.paginated.collection.ts');
var VenuesModel = require('../models/venues.model.ts');
var i18n = require('l10n');

var TheView = GenericView.extend({
    el: '#venues',
    tagName: 'span',
	template: Handlebars.compile(Template),
	superInitialize: GenericView.prototype.initialize,
	collection : null,
	model: null,
	userPrivilege: null,
	options: null,
	isDisplay: false,
	editable: false,
	saved: null,
	filter: {},
	initialize: function (options) {
		var self = this;
		this.userPrivilege = options.userPrivilege;
		this.editable = options.editable;
		if(	options && options.venueId  && options.venueId != null)
		{
			this.saved = options.venueId;
			//this.filter = {venueId: this.saved  };

		}

	},
	load: function(filter)
	{
		//if(this.saved )
		//	filter = $.extend(filter, { venueId: this.saved  });

		//console.info("filter");
		//console.info(filter);

		if(!this.isDisplay || ( filter &&  this.filter.org != filter.org))
		{

			if(filter)
				this.filter = filter;

			if(this.userPrivilege >= 1)
				this.loadData(filter);
			else
			{
				if( (filter && filter.org) || this.saved)
					this.loadData(filter);
				else
					this.show();
			}

			//return false;
		}

		//return true;
	},
	show: function()
	{
		this.render();
	},
	loadData: function(filter)
	{

		var self = this;
		this.showActionProgressBar();
		if(this.editable )
		{
			this.collection = null;
			this.model = new VenuesModel({id : this.saved});
			this.model.fetch({
				success: function(response)
				{
					self.successLoaded(response);
				},
				error: function(response, xhr, status)
				{
					self.errorLoaded(response);
				}
			});
			return;
		}

		this.model = null;
		this.collection = new VenuesCollection();
		this.collection.url = '/rest/api/venues' + this.createFilters(filter);

		this.collection.on('sync', this.successLoaded, this);
		this.collection.on('error', this.errorLoaded, this);
		this.collection.state.pageSize = 999;
		this.collection.getFirstPage();

	},
	createFilters: function(filter)
	{
		if( !filter )
			return "";

		var params = "";
		for (var key in filter) {

		  if(params != "")
		  		params = params + ",";

		  params = params + key + "="+filter[key];

        }

		return "?filter=" + encodeURIComponent(params);
	},
	successLoaded: function(response)
	{
		this.hideActionProgressBar();
		this.render();
	},
	errorLoaded: function(response)
	{
		this.hideActionProgressBar();
		//console.info("errorLoaded");
	},
	superRender: GenericView.prototype.render,
	render: function () {
		this.isDisplay = true;
		this.superRender();

		if(this.collection)
			var data = { data : this.collection.models  };
		else if(this.model)
			var data = { data : [this.model] };

		data = $.extend( data , { label: i18n.t("venue.venue")} );


		if( this.saved )
		{
			data = $.extend( data , { saved: this.saved});
			this.saved = null;
		}
		this.$el.html(this.template(data));


		if(this.editable)
			this.$el.find("select").prop('disabled', true);
	},
	events: {
	},
	clearView: function()
	{
		//console.info("clearView");
		this.isDisplay = false;
		this.$el.removeClass("has-error");
		this.$el.html("");

	},
	isTheDataWrong: function()
	{
		if(this.isDisplay && !this.editable)
		{
			return this.isNotSelect("#venues");
		}
		else
		{
			return false;
		}
	},
	getData: function()
	{
		if(this.isDisplay)
		{
				return this.$el.find("select").val();
		}else
			return null;
	}

});

module.exports = TheView;